export interface ErrorReturn {
    error: string
}

export function isErrorReturn(item: any | ErrorReturn): item is ErrorReturn {
    return (item as ErrorReturn).error !== undefined;
}